module.exports = {"640303001":"新民街道","640303100":"红寺堡镇","640303101":"太阳山镇","640303200":"大河乡","640303201":"新庄集乡","640303202":"柳泉乡","640303400":"工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640303.json
// module id = 3177
// module chunks = 0